import { defineComponent as _defineComponent } from 'vue'
import ConfirmDeleteDialog from '@/components/dialog/ConfirmDeleteDialog.vue';
import NumberInput from '@/components/inputs/NumberInput.vue';
import i18n from '@/i18n';
import {
  isOpenAndUnassigned,
  isUnassignedAndNotOpen,
} from '@/lib/schedule-v2/shiftV2Status';
import { getErrorMessages, maxValue, minValue } from '@/plugins/vuelidate';
import useVuelidate from '@vuelidate/core';
import { computed, reactive } from 'vue';
import { Shift } from '../../../../api/v1';

/* PROPS */

export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteShiftDialog',
  props: {
    actingShift: null,
    showDialog: { type: Boolean },
    loading: { type: Boolean },
    deleteShift: null,
    shiftsAffected: null
  },
  emits: ["cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  actingShift: Shift;
  showDialog: boolean;
  loading: boolean;
  deleteShift: (deletionCount?: number | null) => void;
  shiftsAffected: number;
}



/* EMITS */


/* DATA */
const form = reactive<{ quantity: number }>({
  quantity: props.shiftsAffected,
});

const showNumberInput = computed<boolean>(() => props.shiftsAffected > 1);
const validators = computed(() =>
  showNumberInput.value
    ? {
        quantity: {
          minValue: minValue(1),
          maxValue: maxValue(props.shiftsAffected),
        },
      }
    : {},
);

const v$ = useVuelidate(validators, form, { $autoDirty: true });

/* COMPUTED */
const entity = computed<string>(() => {
  if (isOpenAndUnassigned(props.actingShift)) {
    return i18n.tc('entities.openShift', form.quantity);
  }
  if (isUnassignedAndNotOpen(props.actingShift)) {
    return i18n.tc('entities.unassignedShift', form.quantity);
  }
  return i18n.tc('entities.shift', form.quantity);
});

const deleteDialogHeaderText = computed<string>(() =>
  i18n.tc('heading.genericDeleteEntity', 1, {
    entity: entity.value,
  }),
);

/* COMPUTED */
const confirmDelete = () => {
  if (form.quantity === props.shiftsAffected) {
    props.deleteShift();
    return;
  }
  props.deleteShift(form.quantity);
};

return { __sfc: true,props, emit, form, showNumberInput, validators, v$, entity, deleteDialogHeaderText, confirmDelete, ConfirmDeleteDialog, NumberInput, i18n, getErrorMessages }
}

})